import { INTERFACE_BASE_URL } from "@/config/config";
import axios from "@/config/axios.config";
import shopApi from "@/api/shop";

// 店铺列表
export function shopList(data, noLoading) {
	return axios({
		method: "post",
		url: shopApi.storeListUrl,
		noLoading,
		data,
	});
}

// 店铺详情
export function storeDetail(data) {
	return axios({
		method: "post",
		url: shopApi.storeDetailUrl,
		data,
	});
}

// 评论列表
export function commentList(data) {
	return axios({
		method: "post",
		url: shopApi.commentListUrl,
		data,
	});
}

// 餐品详情
export function mealDetail(data) {
	return axios({
		method: "post",
		url: shopApi.mealDetailUrl,
		data,
	});
}

// 配送时间
export function getSendTime(data) {
	return axios({
		method: "post",
		url: shopApi.getSendTimeUrl,
		data,
	});
}

export function addMeal(data, noToast = false) {
	return axios({
		method: "post",
		url: shopApi.addMealUrl,
		data,
		noToast,
	});
}

// 必选品
export function verifyAnchor(data,store_id, noToast = false) {
    return axios({
        method: "post",
        url: shopApi.verifyAnchorUrl,
        data: {
            meal_id:data,
			store_id:store_id
        },
        noToast
    });
}

// 确认购物车商品
export function verifyCart(data) {
	return axios({
		method: "post",
		url: shopApi.verifyCartUrl,
		data,
		noToast: true,
	});
}


// 扫码点餐
export function desk(data,noLoading){
	return axios({
		method: "post",
		url: shopApi.deskUrl,
		data,
		noLoading
	})
}

export function getBackUpMax(data,noToast=false)
{
	return axios({
		method:"post",
		url:INTERFACE_BASE_URL+"/admin/apiRobot/shpMealLimit",
		data,
		noToast
	})
}
export function in_array(search,array){
    for(var i in array){
        if(array[i]==search){
            return true;
        }
    }
    return false;
}